import { createTheme } from "@mui/material/styles";

const SettingCustomTable = createTheme({
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: "none",
          fontFamily: "red hat display",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#F7F8FF !important",
          color: "#402899",
          fontWeight: 600,
        },
      },
    },
  },
});
export default SettingCustomTable;
